module.exports = __webpack_public_path__ + "e4bcd53b763f7eef9e77f06f88783edf.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/jg-logo.svg
// module id = 988
// module chunks = 0